import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import LoginPage from "@/pages/Login";
import DashboardPage from "@/pages/Dashboard";
import LeadsPage from "@/pages/Leads";
import LeadDetailPage from "@/pages/LeadDetail";
import PropertiesPage from "@/pages/Properties";
import OpportunitiesPage from "@/pages/Opportunities";
import TasksPage from "@/pages/Tasks";
import TeamReportsPage from "@/pages/TeamReports";
import TeamPage from "@/pages/Team";
import ProfilePage from "@/pages/Profile";
import "@/App.css";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="grid min-h-screen place-items-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-[hsl(var(--brand-navy))]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function AdminOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return <AppShell>{children}</AppShell>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Protected><DashboardPage /></Protected>} />
          <Route path="/leads" element={<Protected><LeadsPage /></Protected>} />
          <Route path="/leads/:id" element={<Protected><LeadDetailPage /></Protected>} />
          <Route path="/opportunities" element={<Protected><OpportunitiesPage /></Protected>} />
          <Route path="/tasks" element={<Protected><TasksPage /></Protected>} />
          <Route path="/projects" element={<Protected><PropertiesPage /></Protected>} />
          <Route path="/properties" element={<Protected><PropertiesPage /></Protected>} />
          <Route path="/reports" element={<AdminOnly><TeamReportsPage /></AdminOnly>} />
          <Route path="/team" element={<AdminOnly><TeamPage /></AdminOnly>} />
          <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors closeButton position="top-right" />
    </AuthProvider>
  );
}
